<template>
  <div class="presupuesto-print">
    <img src="../../assets/contenido/banner-print.jpg">
    <div class="davi-curs title-print">Presupuesto Mensual</div>
    <!-- Ingresos -->
    <div class="title-print-two span-red">Ingresos</div>

    <table class="form-calculadora">
      <tr class="form-titles">
        <th v-for="item in nombresUno">
          <span class="span-red davi-curs"> {{item.parteUno}} </span><br> {{item.parteDos}}
        </th>
      </tr>
      <tr v-for="(item, index) in ingresoSalario" v-if="item.valorUno || item.valorDos">
        <td>
          {{item.nombre}}
        </td>
        <td>
          <div class="valor">
            <template v-if="item.valorUno"> ${{item.valorUno}} </template>
            <template v-if="!item.valorUno"> ${{0}} </template>
          </div>
        </td>
        <td class="input-td">
          <div class="valor">
            <template v-if="item.valorDos"> ${{item.valorDos}} </template>
            <template v-if="!item.valorDos"> ${{0}} </template>
          </div>
        </td>
        <td class="text-xs-center">
          <span class="font-red ">{{ingresoSalarioDiferencia[index]}}</span>
        </td>
      </tr>
      <tr>
        <td v-for="(item, index) in ingresoSalarioTotal">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
    </table>

    <!-- Otros ingresos  -->
    <table class="form-calculadora">
      <tr class="form-titles">
        <th>
          <span class="span-red davi-curs"> Otros ingresos mensuales </span>
        </th>
        <th v-for="item in nombresDos">
          <span class="span-red davi-curs"> {{item}} </span>
        </th>
      </tr>
      <tr v-for="(item, index) in otrosIngresoSalario" v-if="item.valorUno || item.valorDos">
        <td>
          {{item.nombre}}
        </td>
        <td>
          <div class="valor">
            <template v-if="item.valorUno"> ${{item.valorUno}} </template>
            <template v-if="!item.valorUno"> ${{0}} </template>
          </div>
        </td>
        <td class="input-td">
          <div class="valor">
            <template v-if="item.valorDos"> ${{item.valorDos}} </template>
            <template v-if="!item.valorDos"> ${{0}} </template>
          </div>
        </td>
        <td class="text-xs-center">
          <span class="font-red ">{{OtrosIngresoSalarioDiferencia[index]}}</span>
        </td>
      </tr>
      <tr>
        <td v-for="(item, index) in OtrosIngresoSalarioTotal">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
    </table>

    <!-- Suma de ingresos -->
    <table class="form-calculadora">
      <tr>
        <td v-for="(item, index) in ingresosMasOtrosIngresos">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
    </table>
    <div class="html2pdf__page-break"></div>
    <br><br>
    <!-- Gastos Fijos -->
    <div class="title-print-two span-red">Gastos fijos</div>

    <table class="form-calculadora">
      <tr class="form-titles">
        <th>
          <span class="span-red davi-curs"> Gastos fijos mensuales </span>
        </th>
        <th v-for="item in nombresDos">
          <span class="span-red davi-curs"> {{item}} </span>
        </th>
      </tr>
      <tr v-for="(item, index) in gastosFijos" v-if="item.valorUno || item.valorDos">
        <td>
          <template v-if="!item.otro">
            {{item.nombre}}
          </template>
          <template v-if="item.otro">
            {{item.otro}}
          </template>
        </td>
        <td>
          <div class="valor">
            <template v-if="item.valorUno"> ${{item.valorUno}} </template>
            <template v-if="!item.valorUno"> ${{0}} </template>
          </div>
        </td>
        <td class="input-td">
          <div class="valor">
            <template v-if="item.valorDos"> ${{item.valorDos}} </template>
            <template v-if="!item.valorDos"> ${{0}} </template>
          </div>
        </td>
        <td class="text-xs-center">
          <span class="font-red ">{{gastosFijosDiferencia[index]}}</span>
        </td>
      </tr>
      <tr>
        <td v-for="(item, index) in gastosFijosTotal">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
    </table>
    
    <div class="html2pdf__page-break"></div>
    <br><br>
    <!-- Gastos variables -->
    <div class="title-print-two span-red"> Gastos variables</div>

    <table class="form-calculadora">
      <tr class="form-titles">
        <th>
          <span class="span-red davi-curs"> Gastos variables mensuales </span>
        </th>
        <th v-for="item in nombresDos">
          <span class="span-red davi-curs"> {{item}} </span>
        </th>
      </tr>
      <tr v-for="(item, index) in gastosVariables" v-if="item.valorUno || item.valorDos">
        <td>
          <template v-if="!item.otro">
            {{item.nombre}}
          </template>
          <template v-if="item.otro">
            {{item.otro}}
          </template>
        </td>
        <td>
          <div class="valor">
            <template v-if="item.valorUno"> ${{item.valorUno}} </template>
            <template v-if="!item.valorUno"> ${{0}} </template>
          </div>
        </td>
        <td class="input-td">
          <div class="valor">
            <template v-if="item.valorDos"> ${{item.valorDos}} </template>
            <template v-if="!item.valorDos"> ${{0}} </template>
          </div>
        </td>
        <td class="text-xs-center">
          <span class="font-red ">{{gastosVariablesDiferencia[index]}}</span>
        </td>
      </tr>
      <tr>
        <td v-for="(item, index) in gastosVariablesTotal">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
    </table>

    <div class="html2pdf__page-break"></div>
    <br><br>
    <!-- Gastos Opcionales -->
    <div class="title-print-two span-red"> Gastos opcionales</div>

    <table class="form-calculadora">
      <tr class="form-titles">
        <th>
          <span class="span-red davi-curs"> Gastos opcionales mensuales </span>
        </th>
        <th v-for="item in nombresDos">
          <span class="span-red davi-curs"> {{item}} </span>
        </th>
      </tr>
      <tr v-for="(item, index) in gastosOpcionales" v-if="item.valorUno || item.valorDos">
        <td>
          <template v-if="!item.otro">
            {{item.nombre}}
          </template>
          <template v-if="item.otro">
            {{item.otro}}
          </template>
        </td>
        <td>
          <div class="valor">
            <template v-if="item.valorUno"> ${{item.valorUno}} </template>
            <template v-if="!item.valorUno"> ${{0}} </template>
          </div>
        </td>
        <td class="input-td">
          <div class="valor">
            <template v-if="item.valorDos"> ${{item.valorDos}} </template>
            <template v-if="!item.valorDos"> ${{0}} </template>
          </div>
        </td>
        <td class="text-xs-center">
          <span class="font-red ">{{gastosOpcionalesDiferencia[index]}}</span>
        </td>
      </tr>
      <tr>
        <td v-for="(item, index) in gastosOpcionalesTotal">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
    </table>

    <!-- Total flujo de caja -->
    <div class="html2pdf__page-break"></div>
    <br><br>
    <div class="davi-curs title-print span-red">Presupuesto</div>
    <p><strong>Teniendo en cuenta sus ingresos y sus gastos, este sería  su flujo de caja mensual</strong></p><br>
    <table class="form-calculadora">
      <tr class="form-titles">
        <th>
          <span class="span-red davi-curs"> Presupuesto </span>
        </th>
        <th v-for="item in nombresDos">
          <span class="span-red davi-curs"> {{item}} </span>
        </th>
      </tr>
      <tr>
        <td v-for="(item, index) in ingresosMasOtrosIngresos">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
      <tr>
        <td v-for="(item, index) in totalGastos">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
      <tr>
        <td v-for="(item, index) in flujoDeCaja">
          <div class="valor-total">
            <template v-if="item"> {{index > 0?'$':''}}{{item}} </template>
            <template v-if="!item"> ${{0}} </template>
          </div>
        </td>
      </tr>
    </table>    

  </div>
</template>

<script>
export default {
  data() {
    return {
      nombresUno: [
        {
          parteUno: "Ingreso por salario mensual",
          parteDos: ""
        },
        {
          parteUno: "Valor real,",
          parteDos: "(Lo efectivamente recibido durante el mes)"
        },
        {
          parteUno: "Valor planeado,",
          parteDos: "(El esperado inicialmente en el presupuesto mensual)"
        },
        {
          parteUno: "Diferencia mensual",
          parteDos: ""
        }
      ],
      nombresDos: [
        "Valor real",
        "Valor planeado",
        "Diferencia mensual"
      ]
    };
  },
  computed: {
    // ingresos
    ingresoSalario() {
      return this.$store.state.ingresoSalario;
    },
    ingresoSalarioDiferencia() {
      return this.$store.getters.ingresoSalarioDiferencia;
    },
    ingresoSalarioTotal() {
      return this.$store.getters.ingresoSalarioTotal;
    },
    // Otros ingresos
    otrosIngresoSalario() {
      return this.$store.state.otrosIngresoSalario;
    },
    OtrosIngresoSalarioDiferencia() {
      return this.$store.getters.OtrosIngresoSalarioDiferencia;
    },
    OtrosIngresoSalarioTotal() {
      return this.$store.getters.OtrosIngresoSalarioTotal;
    },
    // Suma de ingresos
    ingresosMasOtrosIngresos() {
      return this.$store.getters.ingresosMasOtrosIngresos;
    },
    // Gastos fijos
    gastosFijos() {
      return this.$store.state.gastosFijos;
    },
    gastosFijosDiferencia() {
      return this.$store.getters.gastosFijosDiferencia;
    },
    gastosFijosTotal() {
      return this.$store.getters.gastosFijosTotal;
    },
    // Gastos variables
    gastosVariables() {
      return this.$store.state.gastosVariables;
    },
    gastosVariablesDiferencia() {
      return this.$store.getters.gastosVariablesDiferencia;
    },
    gastosVariablesTotal() {
      return this.$store.getters.gastosVariablesTotal;
    },
    // Gastos opcionales
    gastosOpcionales() {
      return this.$store.state.gastosOpcionales;
    },
    gastosOpcionalesDiferencia() {
      return this.$store.getters.gastosOpcionalesDiferencia;
    },
    gastosOpcionalesTotal() {
      return this.$store.getters.gastosOpcionalesTotal;
    },
    // Total gastos
    totalGastos() {
      return this.$store.getters.totalGastos;
    },
    // Flujo de caja
    flujoDeCaja() {
      return this.$store.getters.flujoDeCaja;
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/variables";
.presupuesto-print {
  padding: 10px 50px;
  .title-print {
    font-size: 30px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .title-print-two {
    font-size: 25px;
    font-weight: bold;
  }
  img {
    width: 100%;
  }
  .span-red {
    color: $secondary-red !important;
  }
  .valor {
    border: solid 1px $secondary-red;
    text-align: center;
    font-weight: bold;
  }
  .valor-total {
    text-align: center;
    font-weight: bold;
    color: $secondary-red;
  }
}

.form-calculadora {
  width: 100%;
  margin: 5px auto;
  border-collapse: collapse;
  padding: 10px;
  border: solid 1px #222;
  .form-titles {
    border-bottom: solid 2px #bbb;
  }
  .form-end {
    border-top: solid 2px #bbb;
  }
  .input-td {
    text-align: center;
  }
  tr {
    th,
    td {
      height: 50px;
      width: 25%;
      padding: 5px 10px;
      font-size: 1.2rem;
      line-height: 1.4rem;
      font-weight: normal;
      input {
        border: solid 1px $secondary-red;
        text-align: center;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// FormCalculadoraPrint.vue?6b69b40a